import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 获取用户角色列表
export const getUserRoles = () => {
  return api.get('/roles/')
}

// 获取角色统计信息
export const getRoleStats = (userId = null) => {
  const params = {}
  if (userId) {
    params.user_id = userId
  }
  return api.get('/roles/stats', { params })
}

// 获取设备信息列表（增强版，包含截图、CPU、内存等）
export const getDevicesInfo = (params = {}) => {
  return api.get('/roles/devices', { params })
}

// 获取指定设备的详细信息
export const getDeviceInfo = (windowId) => {
  return api.get(`/roles/devices/${windowId}`)
}

// 部分更新角色（如 adb）
export const updateRole = (data) => {
  return api.post('/roles/update', data)
}

// 创建清空主线通知
export const createClearMainQuestNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空主线',
    state: 1
  })
}

// 创建清空委托通知
export const createClearDelegateNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空委托',
    state: 1
  })
}

// 创建清空支线通知
export const createClearSideQuestNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空支线',
    state: 1
  })
}

// 批量创建清空主线通知
export const batchClearMainQuest = (roleIds) => {
  return api.post('/notifications/batch-clear-mainquest', {
    role_ids: roleIds
  })
}

// 批量创建通知（通用方法）
export const batchCreateNotifications = (roleIds, type) => {
  return api.post('/notifications/batch', {
    role_ids: roleIds,
    type: type
  })
}

// 批量清空支线
export const batchClearSideQuest = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空支线')
}

// 批量清空委托
export const batchClearDelegate = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空委托')
}

// 批量清空每日副本
export const batchClearDailyDungeon = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空每日副本')
}

// 批量清空混沌神殿
export const batchClearSigren = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空混沌神殿')
}

// 批量清空弗尔克范格
export const batchClearPolk = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空弗尔克范格')
}

// 批量清空激战地
export const batchClearBattleground = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空激战地')
}

// 创建清空背包通知
export const createClearInventoryNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空背包',
    state: 1
  })
}

// 批量清空背包
export const batchClearInventory = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空背包')
}

// 批量清空分解
export const batchClearDecompose = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空分解')
}

// 批量清空兑换码
export const batchClearExchangeCode = (roleIds) => {
  return batchCreateNotifications(roleIds, '清空兑换码')
}

// 创建清空每日副本通知
export const createClearDailyDungeonNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空每日副本',
    state: 1
  })
}

// 创建清空混沌神殿通知
export const createClearSigrenNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空混沌神殿',
    state: 1
  })
}

// 创建清空弗尔克范格通知
export const createClearPolkNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空弗尔克范格',
    state: 1
  })
}

// 创建清空激战地通知
export const createClearBattlegroundNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空激战地',
    state: 1
  })
}

// 创建清空兑换码通知
export const createClearExchangeCodeNotification = (roleId) => {
  return api.post('/notifications/', {
    role_id: roleId,
    type: '清空兑换码',
    state: 1
  })
}

// 批量删除角色
export const batchDeleteRoles = (roleIds) => {
  return api.post('/roles/batch-delete', {
    roleIds: roleIds
  })
}

// 获取金币趋势数据（按日；无历史时可能为空数组）
export const getGoldTrends = (days = 30) => {
  return api.get('/roles/gold-trends', {
    params: { days }
  })
}

// 获取大区金币统计
export const getRegionGoldStats = (game) => {
  return api.get('/roles/region-gold-stats', {
    params: { game }
  })
}

// 获取用户的所有分组列表
export const getUserGroups = () => {
  return api.get('/roles/groups')
}

// 设置单个角色的分组
export const setRoleGroup = (roleId, groupName) => {
  return api.post(`/roles/${roleId}/group`, {
    group_name: groupName
  })
}

// 批量设置角色分组
export const batchSetRoleGroup = (roleIds, groupName) => {
  return api.post('/roles/batch-set-group', {
    role_ids: roleIds,
    group_name: groupName
  })
}

// 批量设置 AI 自定义答题
export const batchUpdateAiAnswerCustom = (roleIds, aiAnswerCustom) => {
  return api.post('/roles/batch-update-ai-answer', {
    role_ids: roleIds,
    ai_answer_custom: aiAnswerCustom
  })
}

// 批量设置是否自动答题
export const batchUpdateAutoAnswerEnabled = (roleIds, enabled) => {
  return api.post('/roles/batch-update-auto-answer', {
    role_ids: roleIds,
    auto_answer_enabled: !!enabled
  })
}

// 删除分组
export const deleteGroup = (groupName) => {
  return api.post('/roles/delete-group', {
    group_name: groupName
  })
}